export default __webpack_public_path__ + "static/media/blue-lines-left.710172b6.svg";